import * as React from 'react';
import { InlineText1, InlineText2, Header0 } from '@cian/ui-kit';

import { HoveredLink } from '../HoveredLink';
import { Layout } from '../Layout';

import * as styles from './styles.css';

interface IBuilderProps {
  logoUrl: string;
  name: string;
  yearOfFoundation?: number | null;
  done: React.ReactNode;
  inProgress: React.ReactNode;
  description: string | null;
  url?: string | null;
  onBuilderLinkClick(): void;
}

export function Builder({
  logoUrl,
  name,
  yearOfFoundation,
  done,
  inProgress,
  description,
  url,
  onBuilderLinkClick,
}: IBuilderProps) {
  return (
    <Layout>
      <div className={styles['nav_container']} id="developer">
        <div className={styles['container']}>
          <div className={styles['builder']}>
            {logoUrl && <div className={styles['logo']} style={{ backgroundImage: `url(${logoUrl})` }} />}
            <div className={styles['title']}>
              <InlineText1 color="gray60_100">Застройщик</InlineText1>
              <div className={styles['name']}>
                <Header0 as="h1">{name}</Header0>
              </div>
            </div>
          </div>
          <div>
            <div className={styles['statistic']}>
              {yearOfFoundation && (
                <div>
                  <Header0>{yearOfFoundation}</Header0>
                  <div className={styles['statistic-item-text']}>
                    <InlineText2 fontWeight="bold">
                      год
                      <br />
                      основания
                    </InlineText2>
                  </div>
                </div>
              )}
              {done}
              {inProgress}
            </div>
            {description && (
              <div className={styles['description']}>
                <InlineText1>
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </InlineText1>
              </div>
            )}
            {url && (
              <HoveredLink url={url} childNode={InlineText2} onClick={onBuilderLinkClick}>
                Узнать больше о застройщике
              </HoveredLink>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
